/**
 * Utility functions and helpers used throughout the library.
 *
 * @module utils
 */
/**
 * Checks if we're in dev mode for us
 */
export const isDev = !!import.meta.env.DEV;
/**
 * A no-operation function that does nothing when called.
 * Useful as a placeholder callback or default function value.
 *
 * @example
 * ```tsx
 * import { NOOP } from '../index.js';
 *
 * // Use as a default callback
 * const handleClick = isEnabled ? actualHandler : NOOP;
 *
 * // Use as a placeholder in initial state
 * const [refresh, setRefresh] = useState(() => NOOP);
 * ```
 */
export const NOOP = () => { };
/**
 * Logging utility that only logs in development mode.
 * In production, this is a no-op function.
 *
 * @remarks
 * TODO: Replace with a future mad-logging project
 *
 * @example
 * ```tsx
 * import { log } from '../index.js';
 *
 * log('Debug info:', someData); // Only logs in dev mode
 * ```
 */
export const log = isDev ? console.log : NOOP;
// Export all utilities from submodules
export * from "./collections";
export * from "./files";
export * from "./mocks";
export * from "./ids";
// Export React utility hooks
export { useDeepCompareEffect } from "../hooks/utils";
//# sourceMappingURL=index.js.map